var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:(_vm.conStype),attrs:{"id":("cnzz_stat_icon_" + _vm.cid)}})}
var staticRenderFns = []

export { render, staticRenderFns }